<template>
  <div class="header-menu">
    <!-- <div class="logo">
      <img :src="baseUrl + '/images/logo.png'" alt="">
    </div> -->
    <div class="menu-list">
      <div class="menu" v-for="(item, i) in menuList" :key="i" :class="getClass(item)" @click="changeMenu(item.name)">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { baseUrl } from '@/utils';
import { ref, onMounted, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()
const routeName = ref(route.name)

watchEffect(() => {
  routeName.value = route.name
  if (routeName.value == 'more') {
    routeName.value = 'home'
  }
})

const getClass = (data: any) => {
  let list = ['law', 'language', 'industryNews', 'medicalData', 'medicalRegister']
  let name = routeName.value || ''
  if (list.indexOf(name) > -1) {
    name = 'product'
  }
  return name == data.name ? 'active' : ''
}

const menuList = [
  {
    name: 'home',
    text: '首页'
  },
  {
    name: 'product',
    text: '产品服务'
  },
  {
    name: 'about',
    text: '公司介绍'
  },
  {
    name: 'contact',
    text: '联系我们'
  },
]

const changeMenu = (name: string) => {
  routeName.value = name
  router.push({ name })
}

onMounted(() => {
  if (routeName.value == 'more') {
    routeName.value = 'home'
  }
})
</script>
